import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../Shared/API/config';

export const feeItemApi = createApi({
  reducerPath: 'feeItemApi',
  baseQuery,
  tagTypes: ['FeeItems', 'MergeJobs'],
  endpoints: builder => ({
    getFeeItems: builder.query<any, void>({
      query: () => '/billing/fee-items',
      providesTags: ['FeeItems'],
    }),
    getMergeJobs: builder.query<any, void>({
      query: () => '/billing/merge-jobs',
      providesTags: ['MergeJobs'],
    }),
    createFeeItem: builder.mutation<any, { displayName: string }>({
      query: (body) => ({
        url: '/billing/fee-items',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['FeeItems'],
    }),
    updateFeeItem: builder.mutation<any, { id: number; displayName: string }>({
      query: ({ id, ...body }) => ({
        url: `/billing/fee-items/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['FeeItems'],
    }),
    scheduleMerge: builder.mutation<any, { targetId: number; sourceIds: number[] }>({
      query: (body) => ({
        url: '/billing/fee-items/schedule-merge',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['MergeJobs'],
    }),
    cancelMerge: builder.mutation<any, string>({
      query: (jobId) => ({
        url: `/billing/merge-jobs/${jobId}/cancel`,
        method: 'POST',
      }),
      invalidatesTags: ['MergeJobs'],
    }),
  }),
});

export const {
  useGetFeeItemsQuery,
  useGetMergeJobsQuery,
  useCreateFeeItemMutation,
  useUpdateFeeItemMutation,
  useScheduleMergeMutation,
  useCancelMergeMutation,
} = feeItemApi;
